"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var chroma_js_1 = __importDefault(require("chroma-js"));
var colorVariants_1 = __importDefault(require("./colorVariants"));
var tableColors_1 = __importDefault(require("./tableColors"));
var grayColors_1 = __importDefault(require("./grayColors"));
var inputColors_1 = __importDefault(require("./inputColors"));
var globalColors_1 = __importDefault(require("./globalColors"));
var buttonColors_1 = __importDefault(require("./buttonColors"));
var paginationColors_1 = __importDefault(require("./paginationColors"));
var THEME_BASE_1 = __importStar(require("../../THEME_BASE"));
var utils_1 = require("../../utils");
var mixDisabledColors = function (variant, colors, primaryShade, _a) {
    var textAlt = _a.textAlt, textDefault = _a.textDefault;
    var variantColor = colors[variant][primaryShade];
    var buttonAdjustColor = (0, chroma_js_1.default)(variantColor).luminance() > 0.5 ? textDefault : textAlt;
    var disabledBackground = (0, utils_1.mixColor)(variantColor, buttonAdjustColor, 0.20);
    var disabledColor = (0, utils_1.contrastingColor)(disabledBackground, 'AA');
    return {
        background: disabledBackground,
        color: disabledColor,
    };
};
var generateColors = function (mantineTheme) {
    var _a, _b;
    var colors = mantineTheme.colors;
    var isLightTheme = mantineTheme.colorScheme === THEME_BASE_1.COLOR_SCHEME_LIGHT;
    var primaryShade = mantineTheme.primaryShade[mantineTheme.colorScheme];
    var baseColors = THEME_BASE_1.default.colors[mantineTheme.colorScheme];
    var brandColors = ((_a = mantineTheme.other.customColors) === null || _a === void 0 ? void 0 : _a.brand)
        ? __assign(__assign({}, baseColors.brand), mantineTheme.other.customColors.brand) : baseColors.brand;
    var baseGlobalColors = ((_b = mantineTheme.other.customColors) === null || _b === void 0 ? void 0 : _b.global)
        ? __assign(__assign({}, baseColors.global), mantineTheme.other.customColors.global) : baseColors.global;
    var completeVariant = (0, colorVariants_1.default)(mantineTheme.colorScheme, colors, primaryShade);
    var completeGlobal = (0, globalColors_1.default)(mantineTheme.colorScheme, colors, brandColors, baseGlobalColors);
    var gray = (0, grayColors_1.default)(brandColors.tertiary, brandColors.secondary);
    var table = (0, tableColors_1.default)(mantineTheme.colorScheme, completeVariant, completeGlobal, colors);
    var input = (0, inputColors_1.default)(completeGlobal, gray, completeVariant, mantineTheme.colorScheme, colors);
    var disabledColors = Object.fromEntries(Object.keys(colors)
        .map(function (variant) { return [variant, mixDisabledColors(variant, colors, primaryShade, completeGlobal)]; }));
    var contrastColors = Object.fromEntries(Object.keys(colors)
        .map(function (variant) { return [variant, (0, utils_1.contrastingColor)(colors[variant][primaryShade])]; }));
    var buttonColors = (0, buttonColors_1.default)(mantineTheme.colorScheme, colors, primaryShade);
    var pagination = (0, paginationColors_1.default)(colors);
    return {
        brand: brandColors,
        button: buttonColors,
        contrast: contrastColors,
        disabled: disabledColors,
        section: {
            filled: {
                border: isLightTheme ? colors.gray[1] : colors.gray[9],
                background: isLightTheme ? colors.gray[0] : colors.gray[7],
            },
        },
        global: completeGlobal,
        gray: gray,
        misc: {
            divider: isLightTheme ? colors.gray[1] : colors.gray[9],
            logoColor: isLightTheme ? colors.gray[5] : colors.gray[0],
            stripedBackground: isLightTheme ? colors.gray[0] : (0, utils_1.opacify)(colors.gray[4], 0.35),
        },
        input: input,
        pagination: pagination,
        table: table,
        variant: completeVariant,
        // new
        background: {
            body: isLightTheme ? colors.gray[0] : colors.gray[8],
            content: isLightTheme ? THEME_BASE_1.COLOR_WHITE : colors.gray[6],
            secondaryNav: isLightTheme ? colors.gray[1] : colors.gray[7],
        },
        badges: {
            dotBorder: isLightTheme ? colors.gray[2] : colors.gray[3],
            blue: {
                dot: {
                    color: isLightTheme ? (0, utils_1.opacify)(colors.primary[5], 0.1) : (0, utils_1.opacify)(colors.primary[4], 0.2),
                },
                light: {
                    text: isLightTheme ? colors.primary[5] : colors.primary[4],
                    background: isLightTheme ? colors.primary[5] : colors.primary[4],
                },
                filled: {
                    text: THEME_BASE_1.COLOR_WHITE,
                    background: isLightTheme ? colors.primary[5] : colors.primary[4],
                },
            },
            red: {
                dot: {
                    color: isLightTheme ? colors.danger[5] : colors.danger[4],
                },
                light: {
                    text: isLightTheme ? colors.danger[5] : colors.danger[4],
                    background: isLightTheme ? (0, utils_1.opacify)(colors.danger[5], 0.1) : (0, utils_1.opacify)(colors.danger[4], 0.2),
                },
                filled: {
                    text: THEME_BASE_1.COLOR_WHITE,
                    background: isLightTheme ? colors.danger[5] : colors.danger[4],
                },
            },
            green: {
                dot: {
                    color: colors.success[5],
                },
                light: {
                    text: isLightTheme ? colors.success[7] : colors.success[5],
                    background: (0, utils_1.opacify)(colors.success[5], 0.1),
                },
                filled: {
                    text: THEME_BASE_1.COLOR_WHITE,
                    background: colors.success[5],
                },
            },
            yellow: {
                dot: {
                    color: colors.warning[5],
                },
                light: {
                    text: isLightTheme ? colors.warning[7] : colors.warning[5],
                    background: (0, utils_1.opacify)(colors.warning[5], 0.1),
                },
                filled: {
                    text: colors.warning[9],
                    background: colors.warning[5],
                },
            },
            gray: {
                dot: {
                    color: isLightTheme ? colors.gray[3] : colors.gray[2],
                },
                light: {
                    text: isLightTheme ? colors.gray[5] : colors.gray[1],
                    background: isLightTheme ? (0, utils_1.opacify)(colors.gray[3], 0.1) : (0, utils_1.opacify)(colors.gray[3], 0.2),
                },
                filled: {
                    text: colors.gray[3],
                    background: THEME_BASE_1.COLOR_WHITE,
                },
            },
        },
        buttons: {
            disabledBackground: isLightTheme ? (0, utils_1.opacify)(colors.gray[5], 0.08) : (0, utils_1.opacify)(colors.gray[0], 0.1),
            blue: {
                light: {
                    text: isLightTheme ? colors.primary[5] : colors.primary[4],
                    background: isLightTheme ? (0, utils_1.opacify)(colors.primary[5], 0.1) : (0, utils_1.opacify)(colors.primary[4], 0.2),
                    backgroundHover: isLightTheme ? (0, utils_1.opacify)(colors.primary[5], 0.05) : (0, utils_1.opacify)(colors.primary[4], 0.1),
                },
                filled: {
                    text: THEME_BASE_1.COLOR_WHITE,
                    background: isLightTheme ? colors.primary[5] : colors.primary[4],
                    backgroundHover: isLightTheme ? colors.primary[4] : (0, utils_1.opacify)(colors.primary[4], 0.7),
                },
                outlined: {
                    text: isLightTheme ? colors.primary[5] : colors.primary[4],
                    border: isLightTheme ? colors.primary[2] : (0, utils_1.opacify)(colors.primary[4], 0.5),
                    backgroundHover: isLightTheme ? (0, utils_1.opacify)(colors.primary[5], 0.1) : (0, utils_1.opacify)(colors.primary[4], 0.1),
                },
                subtle: {
                    text: isLightTheme ? colors.primary[5] : colors.primary[4],
                    backgroundHover: isLightTheme ? (0, utils_1.opacify)(colors.primary[5], 0.2) : (0, utils_1.opacify)(colors.primary[4], 0.2),
                },
            },
            red: {
                light: {
                    text: isLightTheme ? colors.danger[5] : colors.danger[4],
                    background: isLightTheme ? (0, utils_1.opacify)(colors.danger[5], 0.1) : (0, utils_1.opacify)(colors.danger[4], 0.2),
                    backgroundHover: isLightTheme ? (0, utils_1.opacify)(colors.danger[5], 0.05) : (0, utils_1.opacify)(colors.danger[4], 0.1),
                },
                filled: {
                    text: THEME_BASE_1.COLOR_WHITE,
                    background: isLightTheme ? colors.danger[5] : colors.danger[4],
                    backgroundHover: isLightTheme ? colors.danger[4] : (0, utils_1.opacify)(colors.danger[4], 0.7),
                },
                outlined: {
                    text: isLightTheme ? colors.danger[5] : colors.danger[4],
                    border: isLightTheme ? colors.danger[2] : (0, utils_1.opacify)(colors.danger[2], 0.4),
                    backgroundHover: isLightTheme ? (0, utils_1.opacify)(colors.danger[5], 0.1) : (0, utils_1.opacify)(colors.danger[4], 0.1),
                },
                subtle: {
                    text: isLightTheme ? colors.danger[5] : colors.danger[4],
                    backgroundHover: isLightTheme ? (0, utils_1.opacify)(colors.danger[5], 0.1) : (0, utils_1.opacify)(colors.danger[4], 0.2),
                },
            },
            gray: {
                light: {
                    text: isLightTheme ? colors.gray[5] : colors.gray[0],
                    background: isLightTheme ? (0, utils_1.opacify)(colors.gray[3], 0.1) : (0, utils_1.opacify)(colors.gray[3], 0.2),
                    backgroundHover: isLightTheme ? (0, utils_1.opacify)(colors.gray[3], 0.05) : (0, utils_1.opacify)(colors.gray[3], 0.1),
                },
                filled: {
                    text: THEME_BASE_1.COLOR_WHITE,
                    background: colors.gray[3],
                    backgroundHover: isLightTheme ? colors.gray[2] : colors.gray[4],
                },
                outlined: {
                    text: isLightTheme ? colors.gray[5] : colors.gray[0],
                    border: isLightTheme ? colors.gray[2] : (0, utils_1.opacify)(colors.gray[3], 0.6),
                    backgroundHover: (0, utils_1.opacify)(colors.gray[3], 0.1),
                },
                subtle: {
                    text: isLightTheme ? colors.gray[5] : colors.gray[0],
                    backgroundHover: isLightTheme ? (0, utils_1.opacify)(colors.gray[3], 0.2) : (0, utils_1.opacify)(colors.gray[3], 0.3),
                },
            },
        },
        cards: {
            background: isLightTheme ? THEME_BASE_1.COLOR_WHITE : colors.gray[4],
            border: isLightTheme ? colors.gray[1] : colors.gray[7],
        },
        charts: {
            containerBackground: isLightTheme ? colors.gray[0] : colors.gray[0],
            containerBorder: isLightTheme ? colors.gray[1] : colors.gray[1],
            lines: isLightTheme ? colors.gray[1] : colors.gray[4],
            highlight: colors.info[5],
            cyan: {
                markerColor: colors.info[5],
                textColor: THEME_BASE_1.COLOR_WHITE,
                fill: (0, utils_1.opacify)(colors.info[5], 0.2),
            },
        },
        icons: {
            icon: isLightTheme ? colors.gray[4] : colors.gray[1],
            active: isLightTheme ? (0, utils_1.opacify)(colors.gray[5], 0.7) : (0, utils_1.opacify)(colors.gray[0], 0.7),
            disabled: isLightTheme ? (0, utils_1.opacify)(colors.gray[5], 0.4) : (0, utils_1.opacify)(colors.gray[0], 0.5),
        },
        link: {
            default: isLightTheme ? colors.primary[5] : colors.primary[4],
            hover: isLightTheme ? colors.primary[6] : colors.primary[3],
            disabled: isLightTheme ? (0, utils_1.opacify)(colors.gray[5], 0.4) : (0, utils_1.opacify)(colors.primary[0], 0.5),
        },
        menu: {
            default: {
                color: isLightTheme ? colors.gray[5] : colors.gray[0],
                hover: isLightTheme ? (0, utils_1.opacify)(colors.gray[3], 0.1) : (0, utils_1.opacify)(colors.gray[4], 0.2),
                activeColor: isLightTheme ? colors.primary[5] : colors.primary[4],
                activeBackground: isLightTheme ? (0, utils_1.opacify)(colors.primary[5], 0.1) : (0, utils_1.opacify)(colors.primary[4], 0.2),
            },
            red: {
                color: {
                    color: isLightTheme ? colors.danger[5] : colors.danger[4],
                    active: isLightTheme ? (0, utils_1.opacify)(colors.danger[5], 0.1) : (0, utils_1.opacify)(colors.danger[4], 0.2),
                },
            },
        },
        newsCards: {
            background: isLightTheme ? colors.gray[1] : colors.gray[5],
        },
        notification: {
            background: isLightTheme ? THEME_BASE_1.COLOR_WHITE : colors.gray[4],
            border: isLightTheme ? colors.gray[1] : colors.gray[4],
            blue: isLightTheme ? colors.primary[1] : colors.primary[4],
            red: isLightTheme ? colors.danger[1] : colors.danger[4],
            green: isLightTheme ? colors.success[1] : colors.success[4],
            progressBackground: colors.gray[5],
        },
        severity: {
            high: (0, utils_1.opacify)(colors.danger[5], 0.75),
            low: (0, utils_1.opacify)(colors.gray[3], 0.75),
            medium: (0, utils_1.opacify)(colors.gray[5], 0.75),
            success: (0, utils_1.opacify)(colors.gray[6], 0.75),
        },
        tabs: {
            hover: isLightTheme ? colors.gray[2] : colors.gray[3],
            active: isLightTheme ? colors.primary[5] : colors.primary[4],
        },
        text: {
            primary: isLightTheme ? colors.gray[5] : colors.gray[0],
            secondary: isLightTheme ? (0, utils_1.opacify)(colors.gray[5], 0.6) : (0, utils_1.opacify)(colors.gray[0], 0.6),
            disabled: isLightTheme ? (0, utils_1.opacify)(colors.gray[5], 0.4) : (0, utils_1.opacify)(colors.gray[0], 0.5),
            severity: {
                success: isLightTheme ? colors.success[6] : colors.success[5],
                danger: isLightTheme ? colors.success[5] : colors.success[4],
            },
        },
    };
};
exports.default = generateColors;
